module.exports = __webpack_public_path__ + "img/netteller.5f9b8f61.svg";